import { cva } from "@agapi/ui/panda/css";
export const badge = cva({
    base: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "fit-content",
        maxWidth: "max-content",
        gap: "2",
        lineHeight: "none",
        backgroundColor: "var(--bgColor)",
        color: "var(--fgColor)",
    },
    variants: {
        size: {
            xs: {
                px: { base: "2", lg: "3" },
                py: { base: "1", lg: "1" },
                gap: "1",
                fontSize: "xs"
            },
            sm: {
                px: { base: "3", lg: "4" },
                py: { base: "1", lg: "1" },
                gap: "1",
                fontSize: "sm"
            },
            md: {
                px: { base: "4", lg: "5" },
                py: { base: "2", lg: "3" },
                fontSize: "sm"
            },
            lg: {
                px: { base: "4", lg: "5" },
                py: { base: "3", lg: "4" },
                fontSize: "md"
            },
        },
        rounded: {
            left: {
                borderLeftRadius: "full",
            },
            right: {
                borderRightRadius: "full",
            },
            full: {
                borderRadius: "full",
            },
        },
        outlined: {
            true: {
                outline: "1px solid var(--borderColor)"
            }
        },
        withoutContent: {
            true: {
                px: { base: "2", lg: "3" },
                py: { base: "2", lg: "3" },
            }
        }
    },
    compoundVariants: [
        {
            size: 'xs',
            withoutContent: true,
            css: { px: { base: "1", lg: "2" }, py: { base: "1", lg: "2" } }
        },
        {
            size: 'sm',
            withoutContent: true,
            css: { px: { base: "2", lg: "3" }, py: { base: "2", lg: "3" } }
        },
        {
            size: 'md',
            withoutContent: true,
            css: { px: { base: "3", lg: "4" }, py: { base: "3", lg: "4" } }
        },
        {
            size: 'lg',
            withoutContent: true,
            css: { px: { base: "4", lg: "5" }, py: { base: "4", lg: "5" } }
        },
    ]
});
